import _ from 'underscore';
import $ from 'jquery';
import legacyInstru from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

export const uurlLevels = {
  Unknown: 'Unknown',
  Account: 'Account',
  Campaign: 'Campaign',
  AdGroup: 'AdGroup',
  Ad: 'Ad',
  AdExtension: 'AdExtension',
  Keyword: 'Keyword',
};

export function testUurl(fn, originalView, params, context, config) {
  const { isParallelTracking, accountFinalUrlSuffix, isInline, level } = originalView;
  const { customerId, userId, accountId, campaignId, adGroupId, entityId } = context;
  const { apiInLog } = config;

  const timeout = 60000;
  const requestDataKeys = ['FinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix'];
  const endPoint = isInline ? 'TestUURLInline' : 'TestUURL';
  const postUrl = `/Campaign/TestUurl/${endPoint}?cid=${customerId}&uid=${userId}&aid=${accountId}&cmpid=${campaignId}&adgid=${adGroupId}&adid=${entityId}&__adcenterAJAX=true`;
  const requestData = _.pick(params, ...requestDataKeys);
  const resultListTrackingTemplate = requestData.TrackingUrlTemplate;

  requestData.AccountFinalUrlSuffix = accountFinalUrlSuffix;
  requestData.isParallelTracking = isParallelTracking;
  requestData.entityId = entityId;
  requestData.level = level;

  if (params.AutotagMsclkId) {
    requestData.autotagMsclkId = true;
  }

  _.forEach(['TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix'], (p) => {
    if (requestData[p] === 'delete_value') {
      if (p === 'UrlCustomParameters') {
        requestData[p] = [];
      } else {
        requestData[p] = '';
      }
    }
  });

  legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,  apiInLog, `RequestUrl: ${postUrl} Payload: ${requestData}`);

  $.advertiser.ajaxPost({
    url: postUrl,
    data: requestData,
    contentType: 'application/json; charset=utf-8',
    ignoreBeforeAjax: true,
    timeout,
    success: (result, textstatus) => {
      let myResult = result;

      if (!result || !_.isArray(result) || !result.length) {
        let  error = '';
        let  code  = 4;

        if (result && result.Errors && result.Errors.length) {
          error = result.Errors[0].Message;
          code  = result.Errors[0].Code > 0 ? result.Errors[0].Code : code;
        }

        legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,  apiInLog, `Unknown Result: ${result} Error: ${error} Status:${textstatus}`);
        myResult = _.defaults({}, { Result: code }, result); // Unknown Error
      } else {
        if (level === 'Account' || level === 'Campaign') {
          myResult.Result = 7; // Test complete
        }

        legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,  apiInLog, `Result: ${result.Result} Status:${textstatus}`);
      }

      myResult.isParallelTracking = !!isParallelTracking;
      myResult.isMultipleResult = level === uurlLevels.Account || level === uurlLevels.Campaign;
      // resultTrackingTemplate is displayed at the top of the v2 of account/campaign level test
      myResult.resultListTrackingTemplate = resultListTrackingTemplate;
      fn.call(originalView, myResult);
    },
    error: (xmlhttprequest, textstatus) => {
      let result;

      if (textstatus === 'timeout') {
        legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,  apiInLog, `Timeout: after ${timeout}ms Status:${textstatus}`);
        result = {
          Result: 3, // Timeout
        };
      } else {
        legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,  apiInLog, `Unknown error: ${xmlhttprequest.responseText} Status:${textstatus}`);
        result = {
          Result: 4, // Unknown Error
        };
      }

      result.isParallelTracking = !!isParallelTracking;
      fn.call(originalView, result);
    },
  });
}
